(function() {
    try {
        // Kiểm tra xem có đang ở trang product detail không
        var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
        if (!isProductPage) return;

        function getNonGlobalId(id) {
            if (!id) return "";
            return String(id).split("/").pop();
        }

        // 1. Xác định Product ID và Handle hiện tại của trang detail
        var currentProductId = null;
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
            currentProductId = String(window.ShopifyAnalytics.meta.product.id);
        } else if (window.meta && window.meta.product) {
            currentProductId = String(window.meta.product.id);
        } else if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct) {
            currentProductId = String(window.tlFreeGiftData.currentProduct.id);
        }

        var currentProductIdNorm = currentProductId ? getNonGlobalId(currentProductId) : "";
        var currentProductHandle = window.location.pathname.split('/products/').pop().split('?')[0].split('#')[0].toLowerCase();

        var currentCollections = [];
        if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct && window.tlFreeGiftData.currentProduct.collections) {
            currentCollections = window.tlFreeGiftData.currentProduct.collections.map(getNonGlobalId);
        }

        function doRedirect() {
            window.location.href = "/";
        }

        // 2. [FREE GIFT] Kiểm tra (Không quan tâm active hay inactive)
        function checkFreeGiftRedirect(rules) {
            if (!rules || !rules.length) return false;
            return rules.some(function(rule) {
                // Đã bỏ check active
                return rule.listChilds && rule.listChilds.some(function(child) {
                    var childProdId = getNonGlobalId(child.product_id);
                    var childShopifyId = getNonGlobalId(child.shopify_id);

                    if (childProdId === currentProductIdNorm || childShopifyId === currentProductIdNorm) {
                        return true;
                    }
                    if (currentCollections.length > 0 && currentCollections.indexOf(childShopifyId) !== -1) {
                        return true;
                    }
                    return false;
                });
            });
        }

        // 3. [PROGRESS BAR] Kiểm tra (Không quan tâm active hay inactive)
        function checkProgressBarRedirect(rules) {
            if (!rules) return false;
            var listRules = [];
            if (Array.isArray(rules)) {
                listRules = rules;
            } else if (typeof rules === 'object') {
                listRules = Object.entries(rules).map(function(item) {
                    return Object.assign({ id: item[0].split("_")[0] }, item[1]);
                });
            }

            return listRules.some(function(rule) {
                // Đã bỏ check rule.status
                if (!rule.milestones) return false;

                return rule.milestones.some(function(milestone) {
                    if (!milestone.gifts) return false;

                    var gifts = [];
                    if (typeof milestone.gifts === 'string') {
                        try { gifts = JSON.parse(milestone.gifts); } catch (e) { return false; }
                    } else if (Array.isArray(milestone.gifts)) {
                        gifts = milestone.gifts;
                    }

                    return gifts && gifts.some(function(gift) {
                        var giftProdId = getNonGlobalId(gift.id || gift.product_id);
                        var giftHandle = gift.handle ? String(gift.handle).toLowerCase() : "";

                        if (giftProdId === currentProductIdNorm || giftHandle === currentProductHandle) {
                            return true;
                        }
                        return false;
                    });
                });
            });
        }

        // A. KIỂM TRA PROGRESS BAR (Sử dụng biến toàn cục tlCartGoalRules)
        function runProgressBarCheck() {
            var rules = window.tlCartGoalRules;
            if (rules && checkProgressBarRedirect(rules)) {
                doRedirect();
                return true;
            }
            return false;
        }

        if (!runProgressBarCheck()) {
            var checkInterval = setInterval(function() {
                if (window.tlCartGoalRules) {
                    clearInterval(checkInterval);
                    runProgressBarCheck();
                }
            }, 100);
            setTimeout(function() { clearInterval(checkInterval); }, 5000);
        }

        // B. KIỂM TRA FREE GIFT (Đọc localStorage + Fetch API để đảm bảo bao quát)
        var shopName = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "";
        var storageKey = "tl-free-gift-local-storage-" + shopName;
        var localDataStr = null;
        
        try { localDataStr = localStorage.getItem(storageKey); } catch (storageErr) {}
        
        if (localDataStr) {
            try {
                var localData = JSON.parse(localDataStr);
                if (localData && localData.rules && checkFreeGiftRedirect(localData.rules)) {
                    doRedirect();
                    return;
                }
            } catch (jsonErr) {}
        }

        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
        var proxyUrl = rootPath + "apps/salepify/free-gift/basic";
        proxyUrl = proxyUrl.replace(/\/+/g, '/'); 
        
        fetch(proxyUrl)
            .then(function(res) { 
                if (!res.ok) throw new Error("Network response not ok");
                return res.json(); 
            })
            .then(function(resData) {
                if (resData && resData.success && resData.data && checkFreeGiftRedirect(resData.data)) {
                    doRedirect();
                }
            })
            .catch(function(err) {});

    } catch (globalErr) {
        console.warn("Salepify Custom Redirect Error ignored:", globalErr.message);
    }
})();
